import api from 'app/shared/utils/api';

// Types
import type {
    CreateMarketingLeadType,
    CreateMarketUpdateType,
    MarketingLeadObjectType,
    UpdateSubscriptionType
} from 'app/shared/types/Marketing';

// @ts-ignore
import { augmentError } from 'app/shared/utils/errors';

export const createMarketingLead = ({ fullAddress = '', unit = '', email = null }: CreateMarketingLeadType) => {
    // @ts-ignore
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const query = state.router.location.query;
            const { utm_source = '', utm_medium = '', utm_campaign = '', utm_content = '' } = query;

            if (__DEV__) {
                return;
            }

            const marketingLeadObject: MarketingLeadObjectType = {
                fullAddress,
                unit,
                marketingLeadType: 'paidInclusionRentEstimator',
                utmSource: utm_source,
                utmMedium: utm_medium,
                utmCampaign: utm_campaign,
                utmContent: utm_content
            };

            if (email) {
                marketingLeadObject.email = email;
            }

            await dispatch(api.marketing.createMarketingLead(marketingLeadObject));

            return true;
        } catch (error) {
            // @ts-ignore
            const shouldLogAction = !error.data || !error.data.action;
            augmentError(error, {
                ...(shouldLogAction && {
                    action: 'Error in MarketingActions#createMarketingLead'
                })
            });

            throw error;
        }
    };
};

export const createMarketUpdate = (params: CreateMarketUpdateType) => {
    // @ts-ignore
    return async (dispatch) => {
        try {
            const requiredParams = {
                email: params.email,
                zpid: params.zpid,
                price: params.price,
                lat: params.lat,
                lon: params.lon
            };

            const optionalParams = {
                listingTypes: params.listingTypes || null,
                propertyTypes: params.propertyTypes || null,
                bedrooms: params.bedrooms || null,
                pets: params.pets || null,
                laundry: params.laundry || null,
                amenities: params.amenities || null,
                orderBy: params.orderBy || null,
                deactivatedDays: params.deactivatedDays || null,
                distanceInMiles: params.distanceInMiles || null
            };

            const marketUpdateParams: CreateMarketUpdateType = Object.assign(requiredParams, optionalParams);

            if (__DEV__) {
                return;
            }

            await dispatch(api.marketing.createMarketUpdate(marketUpdateParams));

            return true;
        } catch (error) {
            // @ts-ignore
            const shouldLogAction = !error.data || !error.data.action;
            augmentError(error, {
                ...(shouldLogAction && {
                    action: 'Error in MarketingActions#createMarketUpdate'
                }),
                marketUpdateParams: params
            });

            throw error;
        }
    };
};

export const updateSubscription = (updateSubscriptionData: UpdateSubscriptionType) => {
    const { email, marketUpdateId, enabled } = updateSubscriptionData;
    // @ts-ignore
    return async (dispatch) => {
        try {
            const updateSubscriptionParams = { email, marketUpdateId, enabled };
            const { data } = await dispatch(api.marketing.updateSubscription(updateSubscriptionParams));
            return data;
        } catch (error) {
            // @ts-ignore
            const shouldLogAction = !error.data || !error.data.action;
            augmentError(error, {
                ...(shouldLogAction && {
                    action: 'Error in MarketingActions#updateSubscription'
                }),
                updateSubscriptionParams: updateSubscriptionData
            });

            throw error;
        }
    };
};
